import styled from 'styled-components'

export const ServicesTable = styled.table`
  width: calc(100% + 16px);
  margin: 0 -8px;

  td,
  th {
    padding: 8px;
    vertical-align: top;
  }
`
